<div class="header-wrapper" title="{{params.displayName}}">
  {{params.displayName}}
</div>
<button #copyBaseBtn title="{{  'plan.dist.copy.base.tooltip' | translate}}" [attr.aria-label]="'plan.dist.copy.base.tooltip' | translate" *ngIf="isResetAvailable" [disabled]="isValid()"
        type="button" class="esp-grid-header-btn copy-base-btn" #copyBasePopover="ngbPopover" [ngbPopover]="confirmReset" triggers="click" container="body" popoverClass="reset-popup" data-testid="copy-base-icon"
        (shown)="onConfirmShown()" (hidden)="onConfirmHidden()"><esp-icon name="copy"></esp-icon></button>


<ng-template #confirmReset>
  <div role="dialog" aria-labelledby="copy-base-confirm-title" tabindex="-1" (keydown.tab)="onConfirmDialogTab($event)">
    <div class="message-text">
      <p id="copy-base-confirm-title">{{"plan.dist.copy.base.msg" | translate }} </p>
    </div>
    <div class="button-response">
      <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'btn.cancel.label' | translate }}" (clicked)="copyBasePopover.close()"></breeze-button>
      <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="copyBase()"></breeze-button>
    </div>
  </div>
</ng-template>

